// extracted by mini-css-extract-plugin
module.exports = {"font-family-emojis":"\"Twemoji\"","font-family-base":"\"Source Sans Pro\",Helvetica,Arial,\"Twemoji\",sans-serif"};